import type React from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/components/ui/utils";
import {
  StatusCancelledIcon,
  StatusCompleteIcon,
  StatusFinalIcon,
  StatusInProgressIcon,
  StatusNewIcon,
  StatusReceivedIcon,
} from "./status-icons";
import { badgeStyles, statusMap } from "./styles";

type Status =
  | "NEW"
  | "RECEIVED"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "REPORTED"
  | "CANCELLED"
  | "new"
  | "received"
  | "in_progress"
  | "completed"
  | "reported"
  | "cancelled"
  | "final";

const StatusReportedIcon = StatusFinalIcon;

const IconMap: Record<Status, typeof StatusNewIcon> = {
  NEW: StatusNewIcon,
  RECEIVED: StatusReceivedIcon,
  IN_PROGRESS: StatusInProgressIcon,
  COMPLETED: StatusCompleteIcon,
  REPORTED: StatusReportedIcon,
  CANCELLED: StatusCancelledIcon,
  new: StatusNewIcon,
  received: StatusReceivedIcon,
  in_progress: StatusInProgressIcon,
  completed: StatusCompleteIcon,
  reported: StatusReportedIcon,
  cancelled: StatusCancelledIcon,
  final: StatusFinalIcon,
};

type StatusIconProps = React.ComponentProps<(typeof IconMap)[Status]> & {
  status: Status;
  noColor?: boolean;
};

export function StatusIcon({
  ref,
  noColor,
  className,
  ...props
}: StatusIconProps) {
  const Icon = IconMap[props.status];
  const iconColor = props.color ?? statusMap[props.status];
  return (
    <Icon
      ref={ref}
      {...props}
      color={noColor ? undefined : iconColor}
      className={cn("size-4", className)}
    />
  );
}

export function StatusBadge({
  status,
  size = "sm",
}: {
  status: Status;
  size?: "sm" | "md" | "lg";
}) {
  const Icon = IconMap[status];
  const color = statusMap[status];
  return (
    <Badge
      shape="square"
      size={size}
      className={cn(
        badgeStyles({ color }),
        "inline-flex gap-1 overflow-hidden",
      )}
    >
      <Icon className={cn(badgeStyles({ color }))} />
      <span style={{ textTransform: "capitalize" }}>
        {status.toLowerCase().replace("_", " ")}
      </span>
    </Badge>
  );
}
